import { oc } from "@orpc/contract";
import type { TPermission } from "@workspace/domain/src/utils/permissions";
import type { AdminAuth } from "../features/auth/schema";

export function calculatePermission(input: {
  requiredPermissions: TPermission[] | true;
  auth: Omit<AdminAuth["AuthData"], "session">;
}) {
  if (
    input.auth.userType === "OWNER" ||
    (Array.isArray(input.requiredPermissions) &&
      !input.requiredPermissions.length)
  ) {
    return true;
  }

  if (input.requiredPermissions === true) {
    return false;
  }

  if (
    !input.requiredPermissions.every(
      (perm) =>
        "permissions" in input.auth.user &&
        input.auth.user.permissions.includes(perm),
    )
  ) {
    return false;
  }

  return true;
}

export const OC = oc.$meta<{
  aragon?: string; // [object]_[verb], e.g. trip_created
  alters?: boolean;
  permissions?: TPermission[] | true;
  noCsrf?: boolean;
  auditLog?: {
    modelName:
      | "TRIP"
      | "CLIENT"
      | "RESERVATION"
      | "AGENCY"
      | "EMPLOYEE"
      | "ROLE"
      | "PAYMENT"
      | "DISCOUNT_CODE"
      | "WITHDRAWAL";
    action: "CREATE" | "UPDATE" | "DELETE";
  };
}>({});
